export default [
  {
    title: 'مدیریت مقاله‌ها',
    icon: 'bx bx-chalkboard',
    children: [
      {
        title: 'مقاله‌ها',
        route: { name: 'blog' },
        resource: 'BlogManager',
        action: 'show',
      },
      {
        title: 'دسته‌بندی‌ها',
        route: { name: 'blogcategory' },
        resource: 'BlogCategoryManager',
        action: 'show',
      },
      {
        title: 'نظرها',
        route: { name: 'blogcomment' },
        resource: 'BlogCommentManager',
        action: 'show',
      },
      // {
      //   title: 'ری دایرکت',
      //   route: { name: 'blogRedirect' },
      //   resource: 'BlogManager',
      //   action: 'show',
      // },
    ],
  },
]
